export enum AlertType {
  WARNING ='warning',
  INFO ='info',
  ERROR ='error',
  SUCCESS = 'success'
}
